<script lang="ts" setup>
import type { Image } from '@/types/Image'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    image: Image
  }>(),
  {}
)

const imageWidthComputed = computed(() => {
  return props.image && props.image.sizes.autoHeight.width > 0 ? props.image.sizes.autoHeight.width : undefined
})

const imageHeightComputed = computed(() => {
  return props.image && props.image.sizes.autoHeight.height > 0 ? props.image.sizes.autoHeight.height : undefined
})
</script>

<template>
  <div class="image-swiper-item">
    <img
      :alt="image.texts.description"
      :height="imageHeightComputed"
      :src="image.sizes.autoHeight.src"
      :srcset="image.sizes.autoHeight.srcset"
      :width="imageWidthComputed"
      class="swiper-img"
      loading="lazy"
    />
    <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
  </div>
</template>
